const TitleArea = (props) => {
    return (
        <div>
            <br />
            <h2>{props.text}</h2>
            <br />
            <h4>{props.msg}</h4>
            <hr />
            <br />
        </div>
    );
};

export default TitleArea;